import React from "react";
import PageHeader from "./PageHeader";
import PageShell from "./PageShell";
import Section from "./Section";
import { MetricStrip } from "./MetricCard";
function renderMetrics(metrics: any): any {
    if (!Array.isArray(metrics) || metrics.length === 0)
        return null;
    return <MetricStrip items={metrics}/>;
}
export function ListPage({ title, subtitle, actions, metrics, beforeSection, sectionTitle = "Listado", sectionSubtitle, sectionClassName = "overflow-hidden", children, className = "", shellSpacing = "md", shellWidth = "full", }: {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    actions?: React.ReactNode;
    metrics?: unknown[];
    beforeSection?: React.ReactNode;
    sectionTitle?: string;
    sectionSubtitle?: React.ReactNode;
    sectionClassName?: string;
    children?: React.ReactNode;
    className?: string;
    shellSpacing?: "sm" | "md" | "lg";
    shellWidth?: "lg" | "xl" | "2xl" | "full";
}): any {
    return (<PageShell spacing={shellSpacing} width={shellWidth} className={className}>
      <PageHeader title={title} subtitle={subtitle} actions={actions}/>
      {renderMetrics(metrics)}
      {beforeSection || null}
      <Section title={sectionTitle} subtitle={sectionSubtitle} className={sectionClassName}>
        {children}
      </Section>
    </PageShell>);
}
export function FormPage({ title, subtitle, actions, metrics, sectionTitle = "Formulario", sectionSubtitle, children, className = "", shellSpacing = "md", shellWidth = "full", }: {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    actions?: React.ReactNode;
    metrics?: unknown[];
    sectionTitle?: string;
    sectionSubtitle?: React.ReactNode;
    children?: React.ReactNode;
    className?: string;
    shellSpacing?: "sm" | "md" | "lg";
    shellWidth?: "lg" | "xl" | "2xl" | "full";
}): any {
    return (<PageShell spacing={shellSpacing} width={shellWidth} className={className}>
      <PageHeader title={title} subtitle={subtitle} actions={actions}/>
      {renderMetrics(metrics)}
      <Section title={sectionTitle} subtitle={sectionSubtitle}>
        {children}
      </Section>
    </PageShell>);
}
export function DetailPage({ title, subtitle, actions, metrics, children, className = "", shellSpacing = "md", shellWidth = "full", }: {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    actions?: React.ReactNode;
    metrics?: unknown[];
    children?: React.ReactNode;
    className?: string;
    shellSpacing?: "sm" | "md" | "lg";
    shellWidth?: "lg" | "xl" | "2xl" | "full";
}): any {
    return (<PageShell spacing={shellSpacing} width={shellWidth} className={className}>
      <PageHeader title={title} subtitle={subtitle} actions={actions}/>
      {renderMetrics(metrics)}
      {children}
    </PageShell>);
}
export function AnalyticsPage({ title, subtitle, actions, metrics, children, className = "", shellSpacing = "lg", shellWidth = "full", }: {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    actions?: React.ReactNode;
    metrics?: unknown[];
    children?: React.ReactNode;
    className?: string;
    shellSpacing?: "sm" | "md" | "lg";
    shellWidth?: "lg" | "xl" | "2xl" | "full";
}): any {
    return (<PageShell spacing={shellSpacing} width={shellWidth} className={className}>
      <PageHeader title={title} subtitle={subtitle} actions={actions}/>
      {renderMetrics(metrics)}
      {children}
    </PageShell>);
}
